import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ContactProfile {
  _id: string;
  profile_picture: string | null;
  company: string;
  kam_for_companies: string[];
  first_name: string;
  last_name: string;
  video_introduction: string | null;
  description: string | null;
  phone_number: string | null;
  position: string;
  sales_region: string | null;
}

export interface User {
  _id: string;
  username: string;
  email: string;
  first_login_finished: boolean;
  contact_profile: ContactProfile;
  roles: string[];
  disabled: boolean;
  external_data: any | null;
}


@Injectable({
  providedIn: 'root',
})
export class UserContextService {
  public user!: User;

  public isFromInternalCompany(): boolean {
    return environment.internalCompanyIds.includes(this.user.contact_profile.company);
  }
}
